import React, { memo } from 'react';
import moment from 'moment';
import { formatDayLabel } from 'util/dates';
import { Holiday } from 'domain/Holiday';

/* =========================
 * Props
 * ========================= */

export interface CalendarHeaderProps {
  dates: Date[];
  columnCount: number;
  headerScrollRef: React.RefObject<HTMLDivElement>;
  holidays: Holiday[];
}

const MIN_COL_WIDTH = 250;


/* =========================
 * Component
 * ========================= */

function CalendarHeader({
  dates,
  columnCount,
  headerScrollRef,
  holidays,
}: CalendarHeaderProps) {

  const isHolidayOrSunday = (date: Date) => {
    const isSunday = date.getDay() === 0;

    const isHoliday = holidays.some(h =>
      moment(h.date).isSame(date, 'day')
    );

    return isSunday || isHoliday;
  };

  return (
    <div className="schHeader">
      <div className="schHeader__corner" />

      <div
        className="schHeader__timeline"
        ref={headerScrollRef}
      >
        <div
          className="schHeader__row"
          style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${columnCount}, minmax(${MIN_COL_WIDTH}px, 1fr))`,
          }}
        >
          {dates.map((d) => (
            <div
              key={d.toISOString()}
              className="schHeader__cell"
              title={d.toDateString()}
              style={{
                backgroundColor: isHolidayOrSunday(d) ? '#FFF4E5' : undefined,
                color: isHolidayOrSunday(d) ? '#D97706' : undefined,
                fontWeight: isHolidayOrSunday(d) ? 700 : undefined,
              }}
            >
              {formatDayLabel(d)}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

/* =========================
 * Memo export
 * ========================= */

export default memo(CalendarHeader);
